import { render, staticRenderFns } from "./NewProperties.vue?vue&type=template&id=3a5d8cc9"
import script from "./NewProperties.vue?vue&type=script&lang=js"
export * from "./NewProperties.vue?vue&type=script&lang=js"
import style0 from "./NewProperties.vue?vue&type=style&index=0&id=3a5d8cc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports